import { render, staticRenderFns } from "./ClassTableList.vue?vue&type=template&id=f5508a40&scoped=true&"
import script from "./ClassTableList.vue?vue&type=script&lang=js&"
export * from "./ClassTableList.vue?vue&type=script&lang=js&"
import style0 from "./ClassTableList.vue?vue&type=style&index=0&id=f5508a40&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.9.8_679359cdb69c218f2f8f476b2ba08796/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5508a40",
  null
  
)

export default component.exports